import axios from "axios";

const createAxios = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token")?.toString(),
    },
  });
};

let Axios = createAxios();
const api_url_kye = process.env.VUE_APP_API_KYE_URL + '/api/v1/';

export function _post(url, data, is_multipart = true) {
  let config = {};

  if (is_multipart) {
    config.headers = {
      "content-type": "multipart/form-data",
    };
  }

  return Axios.post(url, data, config).then((r) => {
    return parse(r, "POST " + url);
  });
}

export function _put(url, data) {
  return Axios.put(url, data)
    .then((r) => {
      return parse(r, "PUT " + url);
    });
}

export function _download(url, config) {
  config = config || { responseType: "blob" };
  return Axios.get(url, config)
    .then((r) => {
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Report.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
      return parse(r, "GET " + url);
    });
}

export function _get(url, config = null, isBlob = false, isKye = false) {
  return Axios.get((isKye ? api_url_kye : '') + url, config)
    .then((r) => {
      return isBlob ? r : parse(r, "GET " + url);
    })
    .catch((e) => {
      return e;
    });
}

export function _delete(url, data) {
  return Axios.delete(url, {
    data: data,
  })
    .then((r) => {
      return parse(r, "DELETE " + url);
    });
}

// eslint-disable-next-line no-unused-vars
function parse(r, text) {
  if (r.data.status != 200) {
    throw new Error(r.data.message);
  }

  return r.data;
}

export function reloadAxios() {
  Axios = createAxios();
}